// src/pages/PowerBackup.jsx
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../components/PowerBackup.css';

const pub = process.env.PUBLIC_URL;

export default function PowerBackup() {
  useEffect(() => {
    AOS.init({ duration: 700, once: false, delay: 50 });
  }, []);

  return (
    <>
      <section
        className="hero-section"
        data-aos="fade-up"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.7),rgba(0,0,0,0.7)), url(${pub}/blog-3.jpg)`,
        }}
      >
        <div className="hero-content">
          <h1>Reliable Power Backup Systems</h1>
          <p>Ensure uninterrupted power for your home or business with our expert solutions.</p>
          <div className="hero-buttons">
            <a href="#power-solutions" className="btn">View Solutions</a>
            <a href="#contact"        className="btn btn-outline">Get a Free Quote</a>
          </div>
        </div>
      </section>

      <section className="service-intro" data-aos="fade-up">
        <div className="service-intro-content">
          <div className="service-intro-image" data-aos="fade-right" data-aos-delay="100">
            <img
              src={`${pub}/Riello-UPS-Systems.png`}
              alt="Power Backup System Installation"
            />
          </div>
          <div className="service-intro-text" data-aos="fade-left" data-aos-delay="200">
            <h2>Keep Your Power On, Always</h2>
            <p>
              Mosike Electrical Contractors offers robust power backup solutions tailored to your
              needs. From residential generators and UPS systems to complex commercial and industrial
              backup power, we ensure you're never left in the dark.
            </p>
            <ul className="service-features">
              <li><i className="fas fa-check-circle"></i> Generator Sales & Installation (Diesel, Petrol, Gas)</li>
              <li><i className="fas fa-check-circle"></i> UPS (Uninterruptible Power Supply) Systems</li>
              <li><i className="fas fa-check-circle"></i> Inverter & Battery Backup Solutions</li>
              <li><i className="fas fa-check-circle"></i> Solar Power Backup Integration</li>
              <li><i className="fas fa-check-circle"></i> Automatic Transfer Switches (ATS)</li>
              <li><i className="fas fa-check-circle"></i> Regular Maintenance & Support</li>
            </ul>
            <a href="#contact" className="btn">Consult Our Experts</a>
          </div>
        </div>
      </section>

      <section className="service-benefits" data-aos="fade-up">
        <h2 className="section-title">Why Invest in Power Backup?</h2>
        <p className="section-description">
          Discover the advantages of having a reliable power backup system.
        </p>
        <div className="benefits-grid">
          <div className="benefit-card" data-aos="fade-up" data-aos-delay="100">
            <div className="benefit-icon"><i className="fas fa-lightbulb"></i></div>
            <div className="benefit-content">
              <h3>Uninterrupted Operations</h3>
              <p>Keep your business running and appliances powered during outages.</p>
            </div>
          </div>
          <div className="benefit-card" data-aos="fade-up" data-aos-delay="200">
            <div className="benefit-icon"><i className="fas fa-shield-alt"></i></div>
            <div className="benefit-content">
              <h3>Protect Equipment</h3>
              <p>Safeguard sensitive electronics from surges and sudden shutdowns.</p>
            </div>
          </div>
          <div className="benefit-card" data-aos="fade-up" data-aos-delay="300">
            <div className="benefit-icon"><i className="fas fa-lock"></i></div>
            <div className="benefit-content">
              <h3>Enhanced Security</h3>
              <p>Ensure security systems and communications stay active.</p>
            </div>
          </div>
          <div className="benefit-card" data-aos="fade-up" data-aos-delay="400">
            <div className="benefit-icon"><i className="fas fa-dollar-sign"></i></div>
            <div className="benefit-content">
              <h3>Prevent Losses</h3>
              <p>Avoid data loss, spoilage, and loss of productivity.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="power-solutions" className="backup-solutions-showcase" data-aos="fade-up">
        <h2 className="section-title">Our Power Backup Solutions</h2>
        <p className="section-description">
          Explore a range of backup systems we offer and install.
        </p>
        <div className="solutions-grid">
          <div className="solution-card" data-aos="zoom-in" data-aos-delay="100">
            <div className="solution-image">
              <img src={`${pub}/genarator.png`} alt="Diesel Generator" />
            </div>
            <div className="solution-content">
              <h3>Generators</h3>
              <p>Reliable diesel, petrol, or gas generators for any application.</p>
              <a href="#contact?solution=generator" className="btn btn-outline">Learn More</a>
            </div>
          </div>
          <div className="solution-card" data-aos="zoom-in" data-aos-delay="200">
            <div className="solution-image">
              <img src={`${pub}/ups back up systems.jpg`} alt="UPS System" />
            </div>
            <div className="solution-content">
              <h3>UPS Systems</h3>
              <p>Instant backup power for critical devices and electronics.</p>
              <a href="#contact?solution=ups" className="btn btn-outline">Learn More</a>
            </div>
          </div>
          <div className="solution-card" data-aos="zoom-in" data-aos-delay="300">
            <div className="solution-image">
              <img src={`${pub}/soloar.png`} alt="Inverter with Batteries" />
            </div>
            <div className="solution-content">
              <h3>Inverter & Battery Systems</h3>
              <p>Silent, scalable backup—often solar-compatible.</p>
              <a href="#contact?solution=inverter" className="btn btn-outline">Learn More</a>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ 
        <h2 className="section-title">Power Backup FAQs</h2>
        <div className="faq-container">
          {[
            {
              q: "What size generator do I need?",
              a:
                "Depends on total wattage. We’ll perform a load calculation to recommend the perfect size.",
            },
            {
              q: "How long does a UPS last?",
              a:
                "Runtime varies by capacity and load—designed to allow safe shutdowns or generator start.",
            },
            {
              q: "Do you offer maintenance for backup systems?",
              a:
                "Yes—comprehensive maintenance plans to keep your system ready and reliable.",
            },
          ].map(({ q, a }, i) => (
            <div className="faq-item" key={i} data-aos="fade-up" data-aos-delay={(i + 1) * 100}>
              <div className="faq-question">
                <span>{q}</span>
                <i className="fas fa-chevron-down" />
              </div>
              <div className="faq-answer">
                <p>{a}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
]*/}

      {/* FINAL CTA */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-content">
          <h2>Secure Your Power Supply Today!</h2>
          <p>Don't wait for the next outage. Contact Mosike Electrical Contractors for a reliable solution.</p>
          <div className="cta-buttons">
            <a href="tel:+1234567890" className="btn btn-white">
              <i className="fas fa-phone"></i> Call Us
            </a>
            <a href="#contact" className="btn btn-outline">
              <i className="fas fa-envelope"></i> Request a Quote
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
